import React from 'react';
import { Element } from '@americanexpress/aqx-components';
import PropTypes from 'prop-types';

const DescriptionList = React.memo(({ list = [], styles = '' }) => (
  <Element Component="ul" className={styles}>
    {list.map(item => (
      <Element Component="li" key={item}>
        {item}
      </Element>
    ))}
  </Element>
));

DescriptionList.propTypes = {
  list: PropTypes.arrayOf(PropTypes.string),
  styles: PropTypes.string
};

export default DescriptionList;
